import { render, staticRenderFns } from "./SetProtractor.vue?vue&type=template&id=42327353"
import script from "./SetProtractor.vue?vue&type=script&lang=js"
export * from "./SetProtractor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports